import React, { useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  Grid,
  FormControl,
  MenuItem,
  InputLabel,
  Select,
} from "@mui/material";
import Navigation from "../Navigation";

const Merch = () => {
  const [Firstname, setFirstname] = useState("");
  const [email, setEmail] = useState("");
  const [referenceNumber, setReferenceNumber] = useState("");
  const [userData, setUserData] = useState(null);
  const [game1, setGame1] = useState("");
  const [game2, setGame2] = useState("");
  const [game3, setGame3] = useState("");
  const [game4, setGame4] = useState("");
  const [merch, setMerch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [dropdownValue, setDropdownValue] = useState("");

  const handleDropdownChange = (event) => {
    setDropdownValue(event.target.value);
  };

  // const searchByRFID = async (event) => {
  //   event.preventDefault();
  //   if (!referenceNumber.trim()) {
  //     toast.error("Please enter a valid RFID number.", {
  //       position: "top-right",
  //       autoClose: 3000,
  //     });
  //     return;
  //   }
  //   setIsLoading(true);
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_ADMIN}/qrCode/getByRFIDwithscorefromLB?Reference_Number=${referenceNumber}`
  //     );
  //     if (response.data && Object.keys(response.data).length > 0) {
  //       console.log("userData", response.data);
  //       setUserData(response.data);
  //       toast.success("User found! Data populated below.", {
  //         position: "top-right",
  //         autoClose: 3000,
  //       });
  //     } else {
  //       toast.error("No user found.", { position: "top-right", autoClose: 3000 });
  //       setUserData(null);
  //     }
  //   } catch (error) {
  //     console.error("Error in RFID search:", error);
  //     toast.error("Error searching for RFID. Please try again.", { position: "top-right", autoClose: 3000 });
  //   } finally {
  //     setReferenceNumber("");
  //     setIsLoading(false);
  //   }
  // };

  const searchByRFID = async (event) => {
    event.preventDefault();
    if (!referenceNumber.trim()) {
      toast.error("Please enter a valid RFID number.", { position: "top-right", autoClose: 3000 });
      return;
    }
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_ADMIN}/qrCode/getByRFIDwithscorefromLB?Reference_Number=${referenceNumber}`
      );
      if (response.data && Object.keys(response.data).length > 0) {
        console.log("userData", response.data);
        // ✅ Contains `rank` along with user data now
        setUserData(response.data);
        if (response.data.message === "User not found") {
          toast.error("No user found.", { position: "top-right", autoClose: 3000 });
          setUserData(null);
        } else {
          toast.success("User found! Data populated below.", { position: "top-right", autoClose: 3000 });
        }
      } else {
        toast.error("No user found.", { position: "top-right", autoClose: 3000 });
        setUserData(null);
      }
    } catch (error) {
      console.error("Error in RFID search:", error);
      toast.error("Error searching for RFID. Please try again.", { position: "top-right", autoClose: 3000 });
    } finally {
      setReferenceNumber("");
      setIsLoading(false);
    }
  };

  const saveOneTicket = async (e) => {
    if (e) e.preventDefault();
    console.log("Saving details...");
    const ticketDetails = {
      // Firstname,
      Email: email || userData?.Email,
      Reference_Number: referenceNumber || userData?.Reference_Number,
      Gift: dropdownValue,
      // gameZone1: false,
      // gameZone2: false,
      // gameZone3: false,
      // gameZone4: false,
      merchCollected: true,
    };
    console.log("Ticket Details:", ticketDetails);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_ADMIN}/qrCode/generateOneRfid`,
        ticketDetails
      );
      const savedDetails = response.data;
      console.log(savedDetails);
      console.log("Ticket Details:", ticketDetails);
      toast("Merch Updated successfully!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setTimeout(() => {
        setDropdownValue("");
        setUserData(null);
      }, 4000);
    } catch (error) {
      toast.error("Failed to save details. Please try again.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      console.error("Error saving details:", error);
    }
  };

  const isEligible =
    userData &&
    userData?.blacklist !== true &&
    new Date(userData?.updatedAt) - new Date(userData?.createdAt) >= 3 * 60 * 60 * 1000;

  return (
    <>
      <style>{css}</style>
      <div className="merch-root">
        {/* Ambient orbs */}
        <div className="merch-orb merch-orb1" />
        <div className="merch-orb merch-orb2" />
        <div className="merch-orb merch-orb3" />
        {/* Dot grid */}
        <div className="merch-grid" />

        <div className="merch-page-card">
          <Navigation />
          <ToastContainer />

          <div className="merch-content">

            {/* ── Search panel ── */}
            <div className="merch-panel merch-search-panel">
              {/* Badge header */}
              <div className="merch-badge">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <rect x="2" y="5" width="20" height="14" rx="3" stroke="#e81b23" strokeWidth="1.8"/>
                  <path d="M7 9h2M7 12h2M7 15h2" stroke="#e81b23" strokeWidth="1.8" strokeLinecap="round"/>
                  <path d="M13 9c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2" stroke="rgba(232,27,35,0.6)" strokeWidth="1.5" strokeLinecap="round"/>
                  <path d="M16 7.5c1.7 1 2.8 2.8 2.8 4.5s-1.1 3.5-2.8 4.5" stroke="rgba(232,27,35,0.3)" strokeWidth="1.4" strokeLinecap="round"/>
                </svg>
                <span>RFID Search</span>
              </div>

              <form onSubmit={searchByRFID} className="merch-form">
                {/* Input */}
                <div className="merch-field-wrap">
                  <div className="merch-field-icon">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                      <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/>
                      <path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                  </div>
                  <input
                    className="merch-input"
                    value={referenceNumber}
                    placeholder="Enter RFID Number"
                    onChange={(e) => setReferenceNumber(e.target.value)}
                    disabled={isLoading}
                    autoFocus
                    required
                  />
                </div>

                <button type="submit" className="merch-btn merch-btn-primary" disabled={isLoading}>
                  {isLoading ? (
                    <><span className="merch-spinner" /> Searching...</>
                  ) : (
                    <>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/>
                        <path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                      Search
                    </>
                  )}
                </button>
              </form>
            </div>

            {/* ── User result panel ── */}
            {userData && (
              <div className="merch-panel merch-result-panel">

                {/* Eligibility banner */}
                <div className={`merch-eligibility-banner ${isEligible ? "merch-eligible" : "merch-ineligible"}`}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    {isEligible
                      ? <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                      : <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
                    }
                  </svg>
                  <span>{isEligible ? "Eligible for Gift" : "Not Eligible for Gift"}</span>
                </div>

                {/* User info grid */}
                <div className="merch-info-grid">
                  <div className="merch-info-item">
                    <span className="merch-info-label">Email / Mobile</span>
                    <span className="merch-info-value">{userData.Email}</span>
                  </div>
                  <div className="merch-info-item">
                    <span className="merch-info-label">Name</span>
                    <span className="merch-info-value">{userData.Firstname}</span>
                  </div>
                  <div className="merch-info-item">
                    <span className="merch-info-label">Rank</span>
                    <span className="merch-info-value" style={{color:"#e81b23"}}>
                      {userData.rank === -1 ? "Played less than 3 hr" : userData.rank ?? "N/A"}
                    </span>
                  </div>
                  <div className="merch-info-item">
                    <span className="merch-info-label">RFID</span>
                    <span className="merch-info-value">{userData.Reference_Number}</span>
                  </div>
                  <div className="merch-info-item">
                    <span className="merch-info-label">Merch Collected</span>
                    <span
                      className="merch-info-value merch-status-pill"
                      style={{
                        background: userData.merchCollected ? "rgba(34,197,94,0.15)" : "rgba(232,27,35,0.12)",
                        color: userData.merchCollected ? "#22c55e" : "#e81b23",
                        border: `1px solid ${userData.merchCollected ? "rgba(34,197,94,0.3)" : "rgba(232,27,35,0.3)"}`,
                      }}
                    >
                      {userData.merchCollected ? "✓ Yes" : "✗ No"}
                    </span>
                  </div>

                  {/* Gift selector */}
                  <div className="merch-info-item merch-info-full">
                    <span className="merch-info-label">Select Gift</span>
                    <select
                      className="merch-select"
                      value={dropdownValue}
                      onChange={handleDropdownChange}
                    >
                      <option value="" disabled>Choose a gift...</option>
                      <option value="All4">All 4</option>
                      <option value="Mayhem">Mayhem</option>
                      <option value="Bonanza">Bonanza</option>
                      <option value="heroes">Heroes</option>
                      <option value="BeautyKart">Beauty Kart</option>
                    </select>
                  </div>
                </div>

                {/* Save button */}
                <button className="merch-btn merch-btn-save" onClick={saveOneTicket}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                    <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    <polyline points="17 21 17 13 7 13 7 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    <polyline points="7 3 7 8 15 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                  Save Ticket
                </button>
              </div>
            )}

          </div>
        </div>
      </div>
    </>
  );
};

export default Merch;

/* ─── Styles ─────────────────────────────────────────────── */
const css = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .merch-root {
    position: fixed; inset: 0;
    background: linear-gradient(160deg, #0a0a0f 0%, #12121a 40%, #0d0d15 100%);
    overflow: hidden;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  }

  /* Dot grid */
  .merch-grid {
    position: fixed; inset: 0;
    background-image: radial-gradient(rgba(232,27,35,0.1) 1px, transparent 1px);
    background-size: 36px 36px;
    pointer-events: none; z-index: 0;
    mask-image: radial-gradient(ellipse 80% 80% at 50% 50%, black 20%, transparent 100%);
    -webkit-mask-image: radial-gradient(ellipse 80% 80% at 50% 50%, black 20%, transparent 100%);
  }

  /* Orbs */
  .merch-orb { position: fixed; border-radius: 50%; pointer-events: none; z-index: 0; }
  .merch-orb1 {
    top:-15%; left:-10%; width:600px; height:600px;
    background: radial-gradient(circle, rgba(232,27,35,0.18) 0%, rgba(232,27,35,0.04) 50%, transparent 70%);
    filter: blur(8px); animation: mOrbFloat1 12s ease-in-out infinite;
  }
  .merch-orb2 {
    bottom:-20%; right:-10%; width:700px; height:700px;
    background: radial-gradient(circle, rgba(180,10,18,0.14) 0%, rgba(120,0,10,0.05) 50%, transparent 70%);
    filter: blur(12px); animation: mOrbFloat2 16s ease-in-out infinite;
  }
  .merch-orb3 {
    top:40%; left:30%; width:400px; height:400px;
    background: radial-gradient(circle, rgba(255,80,80,0.06) 0%, transparent 70%);
    filter: blur(20px); animation: mOrbFloat3 20s ease-in-out infinite;
  }

  /* Page card */
  .merch-page-card {
    position: relative; z-index: 1; height: 100vh; overflow-y: auto;
    background: rgba(14,14,20,0.88);
    backdrop-filter: blur(30px); -webkit-backdrop-filter: blur(30px);
    border: 1px solid rgba(255,255,255,0.06);
    box-shadow: 0 8px 64px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.05);
    animation: mReveal 0.7s cubic-bezier(0.22,1,0.36,1);
  }
  .merch-page-card::-webkit-scrollbar { width: 6px; }
  .merch-page-card::-webkit-scrollbar-track { background: rgba(255,255,255,0.03); border-radius:10px; }
  .merch-page-card::-webkit-scrollbar-thumb { background:linear-gradient(180deg,#e81b23,#7b0008); border-radius:10px; }

  .merch-content {
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    max-width: 680px;
    margin: 0 auto;
  }

  /* ── Panels ── */
  .merch-panel {
    background: linear-gradient(160deg, #111118 0%, #0c0c14 100%);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 20px;
    padding: 28px;
    box-shadow: 0 4px 32px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.05);
    transition: border-color 0.4s ease, box-shadow 0.4s ease;
    animation: mFadeUp 0.6s cubic-bezier(0.22,1,0.36,1) backwards;
  }
  .merch-panel:hover {
    border-color: rgba(232,27,35,0.25);
    box-shadow: 0 8px 40px rgba(232,27,35,0.1), inset 0 1px 0 rgba(255,255,255,0.07);
  }
  .merch-result-panel { animation-delay: 0.08s; }

  /* Badge title */
  .merch-badge {
    display: inline-flex; align-items: center; gap: 10px;
    background: rgba(232,27,35,0.1);
    border: 1px solid rgba(232,27,35,0.3);
    border-radius: 10px; padding: 7px 14px;
    margin-bottom: 24px;
    animation: mRfidPing 2.5s ease-out infinite;
  }
  .merch-badge span {
    color: #f0f0f5; font-size: 1.1rem; font-weight: 700;
    letter-spacing: 0.04em; text-shadow: 0 0 20px rgba(232,27,35,0.5);
  }

  /* Form */
  .merch-form { display: flex; flex-direction: column; gap: 14px; }
  .merch-field-wrap { position: relative; display: flex; align-items: center; }
  .merch-field-icon {
    position: absolute; left: 14px;
    color: rgba(180,180,200,0.4); display: flex; align-items: center; pointer-events: none;
    transition: color 0.3s ease;
  }
  .merch-field-wrap:focus-within .merch-field-icon { color: #e81b23; }
  .merch-input {
    width: 100%;
    background: rgba(255,255,255,0.07);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 12px; color: #f0f0f5;
    font-size: 0.95rem; padding: 13px 16px 13px 42px; outline: none;
    transition: all 0.3s ease;
    font-family: inherit;
  }
  .merch-input::placeholder { color: rgba(180,180,200,0.35); }
  .merch-input:hover { background:rgba(255,255,255,0.1); border-color:rgba(232,27,35,0.35); }
  .merch-input:focus {
    background: rgba(232,27,35,0.06); border-color: #e81b23;
    box-shadow: 0 0 0 3px rgba(232,27,35,0.12);
  }
  .merch-input:disabled { opacity: 0.5; cursor: not-allowed; }

  /* Buttons */
  .merch-btn {
    display: inline-flex; align-items: center; gap: 8px;
    padding: 12px 28px; border: none; border-radius: 12px;
    font-size: 0.9rem; font-weight: 700; cursor: pointer;
    letter-spacing: 0.03em; font-family: inherit;
    transition: all 0.3s cubic-bezier(0.22,1,0.36,1);
    position: relative; overflow: hidden;
  }
  .merch-btn::after {
    content:''; position:absolute; inset:0;
    background:linear-gradient(90deg,transparent,rgba(255,255,255,0.15),transparent);
    background-size:200% 100%; background-position:-200% center;
    transition: background-position 0.4s ease;
  }
  .merch-btn:hover:not(:disabled)::after { background-position:200% center; }
  .merch-btn:disabled { opacity:0.6; cursor:not-allowed; }

  .merch-btn-primary {
    background: #e81b23; color: #fff; align-self: flex-start;
    box-shadow: 0 4px 16px rgba(232,27,35,0.35);
  }
  .merch-btn-primary:hover:not(:disabled) {
    background: #c8121a; transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(232,27,35,0.5);
  }
  .merch-btn-save {
    background: rgba(59,130,246,0.15);
    border: 1px solid rgba(59,130,246,0.35); color: #60a5fa;
    margin-top: 20px;
  }
  .merch-btn-save:hover {
    background: rgba(59,130,246,0.22); transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(59,130,246,0.2);
  }

  /* Spinner */
  .merch-spinner {
    width:14px; height:14px; border-radius:50%;
    border:2px solid rgba(255,255,255,0.3); border-top-color:#fff;
    animation: mSpin 0.7s linear infinite; display:inline-block;
  }

  /* Eligibility banner */
  .merch-eligibility-banner {
    display: flex; align-items: center; gap: 10px;
    padding: 12px 16px; border-radius: 12px;
    font-size: 0.88rem; font-weight: 700; letter-spacing: 0.03em;
    margin-bottom: 20px;
    animation: mFadeUp 0.4s ease-out;
  }
  .merch-eligible {
    background: rgba(34,197,94,0.1); border:1px solid rgba(34,197,94,0.3); color:#22c55e;
  }
  .merch-ineligible {
    background: rgba(232,27,35,0.1); border:1px solid rgba(232,27,35,0.3); color:#e81b23;
  }

  /* Info grid */
  .merch-info-grid {
    display: grid; grid-template-columns: 1fr 1fr; gap: 16px;
  }
  .merch-info-full { grid-column: 1 / -1; }
  .merch-info-item {
    display: flex; flex-direction: column; gap: 5px;
    background: rgba(255,255,255,0.04); border:1px solid rgba(255,255,255,0.06);
    border-radius:12px; padding:14px 16px;
    transition: border-color 0.3s ease;
  }
  .merch-info-item:hover { border-color: rgba(232,27,35,0.2); }
  .merch-info-label {
    font-size:0.65rem; font-weight:700; color:rgba(232,27,35,0.65);
    letter-spacing:0.1em; text-transform:uppercase;
  }
  .merch-info-value {
    font-size:0.95rem; font-weight:600; color:#f0f0f5;
    word-break:break-all;
  }
  .merch-status-pill {
    display:inline-flex; align-items:center;
    padding:3px 10px; border-radius:20px; font-size:0.8rem;
    width:fit-content;
  }

  /* Select */
  .merch-select {
    width:100%; margin-top:4px;
    background:rgba(255,255,255,0.07); border:1px solid rgba(255,255,255,0.1);
    border-radius:10px; color:#f0f0f5; font-size:0.9rem;
    padding:11px 14px; outline:none; cursor:pointer;
    font-family:inherit;
    transition: all 0.3s ease;
    appearance:none;
    background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='rgba(180,180,200,0.5)' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
    background-repeat:no-repeat; background-position:right 14px center;
  }
  .merch-select option { background:#111118; color:#f0f0f5; }
  .merch-select:hover { border-color:rgba(232,27,35,0.4); background-color:rgba(255,255,255,0.1); }
  .merch-select:focus { border-color:#e81b23; box-shadow:0 0 0 3px rgba(232,27,35,0.12); }

  /* Keyframes */
  @keyframes mOrbFloat1 {
    0%,100%{transform:translate(0,0) scale(1)} 33%{transform:translate(60px,-80px) scale(1.15)} 66%{transform:translate(-40px,40px) scale(0.9)}
  }
  @keyframes mOrbFloat2 {
    0%,100%{transform:translate(0,0) scale(1)} 33%{transform:translate(-70px,50px) scale(1.1)} 66%{transform:translate(50px,-60px) scale(0.95)}
  }
  @keyframes mOrbFloat3 {
    0%,100%{transform:translate(0,0) scale(1)} 50%{transform:translate(40px,60px) scale(1.2)}
  }
  @keyframes mReveal { from{opacity:0;transform:translateY(16px)} to{opacity:1;transform:translateY(0)} }
  @keyframes mFadeUp { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
  @keyframes mSpin { to{transform:rotate(360deg)} }
  @keyframes mRfidPing {
    0%{box-shadow:0 0 0 0 rgba(232,27,35,0.4)} 70%{box-shadow:0 0 0 8px rgba(232,27,35,0)} 100%{box-shadow:0 0 0 0 rgba(232,27,35,0)}
  }

  @media (max-width:600px) {
    .merch-content { padding:16px; }
    .merch-info-grid { grid-template-columns:1fr; }
    .merch-info-full { grid-column:auto; }
  }
`;